import { useEffect, useState } from 'react'
import faker from 'faker'
import { matchSorter } from 'match-sorter'
import * as dateFns from 'date-fns'
import * as UIKit from '@planning-center/ui-kit'
import { icons } from './icons'

const appNames = [
  'accounts',
  'api',
  'brand',
  'calendar',
  'cco',
  'churchCenter',
  'general',
  'giving',
  'groups',
  'people',
  'publishing',
  'registrations',
]

function generateFakeData(callback, size = 100) {
  const data = []
  for (let i = 0; i < size; i++) {
    data.push(callback(faker))
  }
  return data
}

function generateRange(max, min = 0) {
  let numbers = []
  for (let index = min; index < max; index++) {
    numbers.push(index)
  }
  return numbers
}

function useUsers(amount = 5) {
  const [users, setUsers] = useState([])
  useEffect(() => {
    fetch(`https://randomuser.me/api/?results=${amount}`)
      .then((response) => response.json())
      .then(({ results }) => setUsers(results))
  }, [amount])
  return users
}

function useCountries() {
  const [countries, setCountries] = useState([])
  useEffect(() => {
    import('world-countries').then((module) => {
      setCountries(module.default)
    })
  }, [])
  return countries
}

export const EDITOR_SCOPE = {
  ...UIKit,
  appNames,
  dateFns,
  generateFakeData,
  generateRange,
  icons,
  matchSorter,
  useCountries,
  useUsers,
}
